module.exports = __webpack_public_path__ + "static/media/icon-video.00186101.svg";